<div class="row">
  <span
    class="col-3 font-weight-bold text-right"
    i18n="@@server-boundage"
  >Serverbindung</span>
  <div class="col-9">
    <ng-select
      [items]="this.servers"
      [clearOnBackspace]="false"
      bindLabel="host"
      bindValue="_id"
      [(ngModel)]="this.room.serverId"
      (ngModelChange)="this.updateRoom.emit(this.room)"
    >
    </ng-select>
    <small
      class="form-text text-muted"
      i18n="@@server-boundage-desctiption"
    >Für das nächste Meeting wird der ausgewälte Server forciert!</small>
  </div>
</div>